import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getDealPdfUrl, getDealSummaryPDF, getShowConfetti } from '../store';
import { setShowConfetti } from '../store/actionCreators';
// import { getAcceptedByBuyer } from '@makemydeal/dr-sales-checkin-store';

/**
 * Fetches the Deal Summary PDF once the deal has been approved by the manager.
 * Owns the PDF-retrieval responsibility for the View Quote / Accepted Deal screens so
 * it stays out of useRequestProposalActions (which handles the request-proposal form/deal actions).
 */
export const useDealSummaryPdf = () => {
    const dispatch = useDispatch();
    const showConfetti: boolean = useSelector(getShowConfetti);
    const dealPdfUrl = useSelector(getDealPdfUrl);

    useEffect(() => {
        if (!dealPdfUrl) dispatch(getDealSummaryPDF());
    }, [dealPdfUrl, dispatch]);

    const onShowConfettiEffect = useCallback(
        (show: boolean) => {
            dispatch(setShowConfetti(show));
        },
        [showConfetti, dispatch]
    );

    return { showConfetti, onShowConfettiEffect };
};
